'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _allenfangReactBootstrapTable = require('allenfang-react-bootstrap-table');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RioTableHeaderColumn = function (_Component) {
    (0, _inherits3.default)(RioTableHeaderColumn, _Component);

    function RioTableHeaderColumn() {
        (0, _classCallCheck3.default)(this, RioTableHeaderColumn);
        return (0, _possibleConstructorReturn3.default)(this, (RioTableHeaderColumn.__proto__ || Object.getPrototypeOf(RioTableHeaderColumn)).apply(this, arguments));
    }

    (0, _createClass3.default)(RioTableHeaderColumn, [{
        key: 'getCaret',
        value: function getCaret(direction) {
            switch (direction) {
                case 'asc':
                    return _react2.default.createElement('span', { className: 'rioglyph rioglyph-arrow-up sortIcon' });
                case 'desc':
                    return _react2.default.createElement('span', { className: 'rioglyph rioglyph-arrow-down sortIcon' });
                default:
                    return undefined;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var customProps = (0, _extends3.default)({}, this.props, {
                caretRender: this.props.caretRender || this.getCaret,
                sort: this.props.sortOrder || this.props.sort
                // sortFunc: has already been set in the render() method of RioBootstrapTable, see comment right there
                // sortOrder: has already been set in the render() method of RioBootstrapTable, see comment right there
            });

            return _react2.default.createElement(
                _allenfangReactBootstrapTable.TableHeaderColumn,
                customProps,
                this.props.children
            );
        }
    }]);
    return RioTableHeaderColumn;
}(_react.Component);

exports.default = RioTableHeaderColumn;


RioTableHeaderColumn.propTypes = (0, _extends3.default)({}, _allenfangReactBootstrapTable.TableHeaderColumn.propTypes, {
    sortOrder: _propTypes2.default.string
});